import { render } from "./TaskDetails.vue?vue&type=template&id=6ba70972&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=6ba70972&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6ba70972"

export default script